export default __webpack_public_path__ + "static/media/noImage.55c935c1.png";